"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManifestType = void 0;
var ManifestType;
(function (ManifestType) {
    ManifestType["PROJECT_JSON"] = "project.json";
    ManifestType["DOTNET_CORE"] = "dotnet-core";
    ManifestType["PACKAGES_CONFIG"] = "packages.config";
    ManifestType["PAKET"] = "paket";
})(ManifestType || (exports.ManifestType = ManifestType = {}));
//# sourceMappingURL=types.js.map